import { useEffect } from "react"
import { connect } from "react-redux"
import BVAInput from "../../../../components/BVAInput/BVAInput";
import {
  addCustomFieldToAssetSaleProceedsWorksheet,
  generateAssetSaleProceedsWorksheet,
  updateAssetSaleProceedsWorksheet, updateCustomFieldOnAssetSaleProceedsWorksheet
} from "../../../../store/modules/financials/actions";
import BVAButton from "../../../../components/BVAButton/BVAButton";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyFormatter from "currency-formatter";
import {Divider} from "@mui/material";
import CustomField from "../../../../models/CustomField";

function AssetSaleProceedsWorksheet({
  assetSaleProceedsWorksheet,
  dispatchGenerateAssetSaleProceedsWorksheet,
  dispatchUpdateAssetSaleProceedsWorksheet,
  dispatchUpdateCustomFieldOnAssetSaleProceedsWorkSheet,
  dispatchAddCustomFieldToAssetSaleProceedsWorksheet
}) {
  // Watcher
  useEffect(() => {
    dispatchGenerateAssetSaleProceedsWorksheet()
  }, [])

  // Methods
  const handleSellingExpensesOnChange = (key, value) => {
    dispatchUpdateAssetSaleProceedsWorksheet({
      sellingExpenses: {
        [key]: value
      }
    })
  }

  const handleAccountsPayableOnChange = (key, value) => {
    dispatchUpdateAssetSaleProceedsWorksheet({
      accountsPayable: {
        [key]: value
      }
    })
  }

  const handleOtherExpensesNeededToCloseOnChange = (key, value) => {
    dispatchUpdateAssetSaleProceedsWorksheet({
      otherExpensesNeededToClose: {
        [key]: value
      }
    })
  }

  const handleTotalCurrentAssetsKeptBySellerOnChange = (key, value) => {
    dispatchUpdateAssetSaleProceedsWorksheet({
      totalCurrentAssetsKeptBySeller: {
        [key]: value
      }
    })
  }


  const handleExistingLiabilitiesAssumedByBuyerOnChange = (key, value) => {
    dispatchUpdateAssetSaleProceedsWorksheet({
      existingLiabilitiesAssumedByBuyer: {
        [key]: value
      }
    })
  }

  const handleCustomFieldOnCreation = (section) => {
    dispatchAddCustomFieldToAssetSaleProceedsWorksheet({ section })
  }

  const handleCustomFieldValueOnUpdate = ({ section, index, name, value }) => {
    const customFields = assetSaleProceedsWorksheet[section].customFields.map((customField, _index) => {
      if (_index === index) {
        const _customField = { ...customField }
        if (name || name === "") _customField.name = name
        if (value || value === 0) _customField.value = CurrencyFormatter.unformat(value, { code: "USD" })

        return _customField
      }

      return customField
    })

    dispatchUpdateCustomFieldOnAssetSaleProceedsWorkSheet({ section, customFields })
  }

  const handleDeleteCustomField = ({ section, index }) => {
    const customFields = assetSaleProceedsWorksheet[section].customFields.filter((customField, _index) => {
      if (_index === index) return false

      return true
    })

    dispatchUpdateCustomFieldOnAssetSaleProceedsWorkSheet({ section, customFields })
  }

  const handleProceedsSummaryCustomField = (customFieldKey, customFieldAttribute, customFieldValue) => {
    let customField = null
    let _customFieldValue = customFieldValue
    if (customFieldAttribute === "value") {
      _customFieldValue = CurrencyFormatter.unformat(customFieldValue, { code: "USD" })
    }

    if (customFieldKey === "customFieldToAdd") {
      customField = new CustomField({
        ...assetSaleProceedsWorksheet.customFieldToAdd,
        [customFieldAttribute]: _customFieldValue
      })
    }
    if (customFieldKey === "customFieldToSubtract") {
      customField = new CustomField({
        ...assetSaleProceedsWorksheet?.customFieldToSubtract,
        [customFieldAttribute]: _customFieldValue
      })
    }

    dispatchUpdateAssetSaleProceedsWorksheet({ [customFieldKey]: customField })
  }

  return (
    <section>
      <div className="mt-10 flex justify-center">
        <div className="w-full max-w-2xl mr-10">
          <h2 className="text-center font-bold text-xl">Cash at Closing Estimate</h2>
          <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
            <label className="font-semibold">1. Cash Down Payment</label>
            <label className="font-semibold">{assetSaleProceedsWorksheet?.cashDownPaymentFormatted}</label>
          </div>
          <div className="mt-10">
            <h3 className="px-4 font-semibold text-lg">2. Selling Expenses</h3>
            <div className="mt-2 border p-5 rounded-lg">
              <div className="flex justify-between items-center">
                <label>Brokerage Fees</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.sellingExpenses?.brokerageFees}
                    onChange={(value) => handleSellingExpensesOnChange("brokerageFees", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Filings & Recordings</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.sellingExpenses?.filingsAndRecordings}
                    onChange={(value) => handleSellingExpensesOnChange("filingsAndRecordings", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Attorney's Fees</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.sellingExpenses?.attorneyFees}
                    onChange={(value) => handleSellingExpensesOnChange("attorneyFees", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Accountant's Fees</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.sellingExpenses?.accountantFees}
                    onChange={(value) => handleSellingExpensesOnChange("accountantFees", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Escrow Fees</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.sellingExpenses?.escrowFees}
                    onChange={(value) => handleSellingExpensesOnChange("escrowFees", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              {assetSaleProceedsWorksheet?.sellingExpenses?.customFields.map((customField, index) => (
                <div className="flex justify-between items-center mt-2">
                  <BVAInput
                    value={customField?.name}
                    placeholder="Item name"
                    type="text"
                    size="small"
                    onChange={(value) => handleCustomFieldValueOnUpdate({
                      section: "sellingExpenses",
                      index,
                      name: value
                    })}/>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={customField?.value}
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "sellingExpenses",
                        index,
                        value
                      })} />
                    <div className="ml-2">
                      <BVAButton
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}
                        onClick={() => handleDeleteCustomField({ section: "sellingExpenses", index })} />
                    </div>
                  </div>
                </div>
              ))}
              <div className="mt-10 flex justify-center border rounded p-5">
                <BVAButton
                  kind="primary-outlined"
                  slimHeight
                  onClick={() => handleCustomFieldOnCreation("sellingExpenses")}>
                  Add Item
                </BVAButton>
              </div>
            </div>
            <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
              <label>Total Selling Expenses</label>
              <label>{assetSaleProceedsWorksheet?.sellingExpenses?.totalSellingExpensesFormatted}</label>
            </div>
          </div>
          <div className="mt-10">
            <h3 className="px-4 font-semibold text-lg">3. Accounts Payable (Not Assumed by Purchaser)</h3>
            <div className="mt-2 border p-5 rounded-lg">
              <div className="flex justify-between items-center">
                <label>Payroll Payables </label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.accountsPayable?.payrollPayables}
                    onChange={(value) => handleAccountsPayableOnChange("payrollPayables", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Sales Tax Payables</label>
                <div className="flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.accountsPayable?.salesTaxPayables}
                    onChange={(value) => handleAccountsPayableOnChange("salesTaxPayables", value)} />
                  <div className="ml-2">
                    <BVAButton disabled shape="circle" iconButton icon={{ url: DeleteIcon }} />
                  </div>
                </div>
              </div>
              {assetSaleProceedsWorksheet?.accountsPayable?.customFields.map((customField, index) => (
                <div className={"flex justify-between items-center mt-2"}>
                  <BVAInput
                    value={customField?.name}
                    placeholder="Item name"
                    type="text"
                    size="small"
                    onChange={(value) => handleCustomFieldValueOnUpdate({
                      section: "accountsPayable",
                      index,
                      name: value
                    })}/>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={customField?.value}
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "accountsPayable",
                        index,
                        value
                      })} />
                    <div className="ml-2">
                      <BVAButton
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}
                        onClick={() => handleDeleteCustomField({ section: "accountsPayable", index })} />
                    </div>
                  </div>
                </div>
              ))}
              <div className="mt-10 flex justify-center border rounded p-5">
                <BVAButton
                  kind="primary-outlined"
                  slimHeight
                  onClick={() => handleCustomFieldOnCreation("accountsPayable")}>
                  Add Item
                </BVAButton>
              </div>
            </div>
            <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
              <label>Total Accounts Payable</label>
              <label>{assetSaleProceedsWorksheet?.accountsPayable?.totalAccountsPayableFormatted}</label>
            </div>
          </div>
          <div className="mt-10">
            <h3 className="px-4 font-semibold text-lg">4. Long Term Debt (Not Assumed by Purchaser)</h3>
            <div className="mt-2 border p-5 rounded-lg">
              {assetSaleProceedsWorksheet?.longTermDebtsNotAssumedByPurchaser?.longTermDebts?.map((longTermDebt) => (
                <div className="flex justify-between items-center mb-2 last:mb-0">
                  <label>{longTermDebt?.name}</label>
                  <label>{longTermDebt?.amountFormatted}</label>
                </div>
              ))}
              {assetSaleProceedsWorksheet?.longTermDebtsNotAssumedByPurchaser?.customFields.map((customField, index) => (
                <div className={"flex justify-between items-center mt-2"}>
                  <BVAInput
                    value={customField?.name}
                    placeholder="Item name"
                    type="text"
                    size="small"
                    onChange={(value) => handleCustomFieldValueOnUpdate({
                      section: "longTermDebtsNotAssumedByPurchaser",
                      index,
                      name: value
                    })}/>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={customField?.value}
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "longTermDebtsNotAssumedByPurchaser",
                        index,
                        value
                      })} />
                    <div className="ml-2">
                      <BVAButton
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}
                        onClick={() => handleDeleteCustomField({ section: "longTermDebtsNotAssumedByPurchaser", index })} />
                    </div>
                  </div>
                </div>
              ))}
              <div className={`${assetSaleProceedsWorksheet?.longTermDebtsNotAssumedByPurchaser?.hasItems ? "mt-10" : ""} 
              flex justify-center border rounded p-5`}>
                <BVAButton
                  kind="primary-outlined"
                  slimHeight
                  onClick={() => handleCustomFieldOnCreation("longTermDebtsNotAssumedByPurchaser")}>
                  Add Item
                </BVAButton>
              </div>
            </div>
            <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
              <label>Total Long Term Debt</label>
              <label>{assetSaleProceedsWorksheet?.longTermDebtsNotAssumedByPurchaser?.totalLongTermDebtNotAssumedByPurchaserFormatted}</label>
            </div>
          </div>
          <div className="mt-10">
            <h3 className="px-4 font-semibold text-lg">5. Other Expenses Needed to Close</h3>
            <div className="mt-2 border p-5 rounded-lg">
              <div className="flex justify-between items-center">
                <label>Equipment Repair</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.otherExpensesNeededToClose?.equipmentRepair}
                    onChange={(value) => handleOtherExpensesNeededToCloseOnChange("equipmentRepair", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Equipment Replace</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.otherExpensesNeededToClose?.equipmentReplace}
                    onChange={(value) => handleOtherExpensesNeededToCloseOnChange("equipmentReplace", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Compliance with Governmental Agencies</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.otherExpensesNeededToClose?.complianceWithGovernmentalAgencies}
                    onChange={(value) => handleOtherExpensesNeededToCloseOnChange("complianceWithGovernmentalAgencies", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              {assetSaleProceedsWorksheet?.otherExpensesNeededToClose?.customFields.map((customField, index) => (
                <div className={"flex justify-between items-center mt-2"}>
                  <BVAInput
                    value={customField?.name}
                    placeholder="Item name"
                    type="text"
                    size="small"
                    onChange={(value) => handleCustomFieldValueOnUpdate({
                      section: "otherExpensesNeededToClose",
                      index,
                      name: value
                    })}/>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={customField?.value}
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "otherExpensesNeededToClose",
                        index,
                        value
                      })} />
                    <div className="ml-2">
                      <BVAButton
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}
                        onClick={() => handleDeleteCustomField({ section: "otherExpensesNeededToClose", index })} />
                    </div>
                  </div>
                </div>
              ))}
              <div className="mt-10 flex justify-center border rounded p-5">
                <BVAButton
                  kind="primary-outlined"
                  slimHeight
                  onClick={() => handleCustomFieldOnCreation("otherExpensesNeededToClose")}>
                  Add Item
                </BVAButton>
              </div>
            </div>
            <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
              <label>Total Other Expenses</label>
              <label>{assetSaleProceedsWorksheet?.otherExpensesNeededToClose?.totalOtherExpensesNeededToCloseFormatted}</label>
            </div>
          </div>
          <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
            <label className="font-semibold">6. Total Sales Expenses and Other</label>
            <label className="font-semibold">
              {assetSaleProceedsWorksheet?.totalSalesAndOtherExpensesFormatted}
            </label>
          </div>
          <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
            <label className="font-semibold">7. Net Cash After Selling And Expenses</label>
            <label className="font-semibold">
              {assetSaleProceedsWorksheet?.netCashAfterSellingAndExpensesFormatted}
            </label>
          </div>
          <div className="mt-10">
            <h3 className="px-4 font-semibold text-lg">8. Total Current Assets Kept By Seller</h3>
            <div className="mt-2 border p-5 rounded-lg">
              {assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.currentAssets?.map((currentAsset, index) => (
                <div key={index} className="flex justify-between items-center mt-2">
                  <label>{currentAsset?.name}</label>
                  <div className="ml-2 flex items-center">
                    <label>{currentAsset?.amountFormatted}</label>
                    <div className="ml-2">
                      <BVAButton
                        disabled
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}/>
                    </div>
                  </div>
                </div>
              ))}
              <div className="flex justify-between items-center mt-2">
                <label>Return of Lease Deposit</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.returnOfLeaseDeposit}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("returnOfLeaseDeposit", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Petty Cash</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.pettyCash}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("pettyCash", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Prorated Rent</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.proratedRent}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("proratedRent", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Utility Deposit</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.utilityDeposit}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("utilityDeposit", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Prorated Taxes</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.proratedTaxes}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("proratedTaxes", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              <div className="flex justify-between items-center mt-2">
                <label>Rebate for Prepaid Expenses</label>
                <div className="ml-2 flex items-center">
                  <BVAInput
                    size="small"
                    textAlign="end"
                    value={assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.rebateForPrepaidExpenses}
                    onChange={(value) => handleTotalCurrentAssetsKeptBySellerOnChange("rebateForPrepaidExpenses", value)}/>
                  <div className="ml-2">
                    <BVAButton
                      disabled
                      shape="circle"
                      iconButton
                      icon={{ url: DeleteIcon }}/>
                  </div>
                </div>
              </div>
              {assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.customFields.map((customField, index) => (
                <div className={"flex justify-between items-center mt-2"}>
                  <BVAInput
                    value={customField?.name}
                    placeholder="Item name"
                    type="text"
                    size="small"
                    onChange={(value) => handleCustomFieldValueOnUpdate({
                      section: "totalCurrentAssetsKeptBySeller",
                      index,
                      name: value
                    })}/>
                  <div className="flex items-center">
                    <BVAInput
                      size="small"
                      textAlign="end"
                      value={customField?.value}
                      onChange={(value) => handleCustomFieldValueOnUpdate({
                        section: "totalCurrentAssetsKeptBySeller",
                        index,
                        value
                      })} />
                    <div className="ml-2">
                      <BVAButton
                        shape="circle"
                        iconButton
                        icon={{ url: DeleteIcon }}
                        onClick={() => handleDeleteCustomField({ section: "totalCurrentAssetsKeptBySeller", index })} />
                    </div>
                  </div>
                </div>
              ))}
              <div className="mt-10 flex justify-center border rounded p-5">
                <BVAButton
                  kind="primary-outlined"
                  slimHeight
                  onClick={() => handleCustomFieldOnCreation("totalCurrentAssetsKeptBySeller")}>
                  Add Item
                </BVAButton>
              </div>
            </div>
            <div className="mt-4 border p-5 rounded-lg bg-neutral-100 flex items-center justify-between">
              <label>Total Additions to Seller's Cash Proceeds</label>
              <label>{assetSaleProceedsWorksheet?.totalCurrentAssetsKeptBySeller?.totalCurrentAssetsKeptBySellerFormatted}</label>
            </div>
          </div>
          <div className="mt-10 border p-5 rounded-lg bg-neutral-200 flex items-center justify-between">
            <label className="font-semibold">9. Estimated Total Net Cash Proceeds to Seller</label>
            <label className="font-semibold">{assetSaleProceedsWorksheet?.estimatedTotalNetCashProceedsToSellerFormatted}</label>
          </div>
        </div>
      </div>
    </section>
  )
}


const mapStateToProps = (state) => ({
  assetSaleProceedsWorksheet: state.financials.assetSaleProceedsWorksheet
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateAssetSaleProceedsWorksheet() {
    dispatch(generateAssetSaleProceedsWorksheet())
  },

  dispatchUpdateAssetSaleProceedsWorksheet({
    sellingExpenses,
    accountsPayable,
    otherExpensesNeededToClose,
    totalCurrentAssetsKeptBySeller,
    existingLiabilitiesAssumedByBuyer,
    customFieldToAdd,
    customFieldToSubtract
  }) {
    dispatch(updateAssetSaleProceedsWorksheet({
      sellingExpenses,
      accountsPayable,
      otherExpensesNeededToClose,
      totalCurrentAssetsKeptBySeller,
      existingLiabilitiesAssumedByBuyer,
      customFieldToAdd,
      customFieldToSubtract
    }))
  },

  dispatchUpdateCustomFieldOnAssetSaleProceedsWorkSheet({ section, customFields }){
    dispatch(updateCustomFieldOnAssetSaleProceedsWorksheet({ section, customFields }))
  },
  dispatchAddCustomFieldToAssetSaleProceedsWorksheet({ section }){
    dispatch(addCustomFieldToAssetSaleProceedsWorksheet({ section }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AssetSaleProceedsWorksheet)